export default __webpack_public_path__ + "static/media/logo_single.674c5595.png";